import { gql } from "@apollo/client"
import craftApolloClient from "../api/apollo"

import Head from 'next/head'

import { Header, HeaderShim } from '../../fuselage/global/header/header'

import { GetBizzaboPartersByLevel } from '../../lib/bizzabo-partner-levels'
import { GetBizzaboPartners } from "../../lib/bizzabo-partners"



function Partners({ seomatic, partnerData }) {

	// seo

	let metaTitle = JSON.parse(seomatic.metaTitleContainer)
    let metaTags = JSON.parse(seomatic.metaTagContainer) 

	// console.log('bizzabo partner data:', partnerData)


	return (
		<>

			<Head>
                <title>{metaTitle.title.title}</title>

                <meta name="description" content={metaTags.description.content} />
                <meta name="referrer" content={metaTags.referrer.content} />
                {/* <meta name="robots" content={metaTags.robots.content} /> */}
                <meta content={metaTags['og:locale'].content} property="og:locale" />
                <meta content={metaTags['og:site_name'].content} property="og:site_name" />
                <meta content={metaTags['og:type'].content} property="og:type" />
                <meta content={metaTags['og:url'].content} property="og:url" />
                <meta content={metaTags['og:title'].content} property="og:title" />
                <meta content={metaTags['og:description'].content} property="og:description" />
                <meta content={metaTags['og:image'].content} property="og:image"></meta>  
            </Head>


			<HeaderShim />

			<section className="block bg-white">
				<div className="container center">
					<p className="fs-0 fw-700 lh-1 c-primary">IDEEA 2023 Sponsors <span>&amp; Partners</span></p>
				</div>
				                
                { GetBizzaboPartersByLevel( 2, partnerData ) }
                { GetBizzaboPartersByLevel( 4, partnerData ) }
                { GetBizzaboPartersByLevel( 5, partnerData ) }
                { GetBizzaboPartersByLevel( 6, partnerData ) }
                { GetBizzaboPartersByLevel( 7, partnerData ) }
                { GetBizzaboPartersByLevel( 8, partnerData ) }


			</section>
		
		</>
	)
}

export async function getStaticProps() {

	const cmsData = await craftApolloClient().query({
        query: gql`
			query SEO {
				entry(site: "${process.env.SITE_HANDLE}", id: 22409) {
					title
					seomatic (asArray: true) {
						metaTitleContainer
						metaTagContainer
					}
				}
			}
        `
    })

	const partners = await fetch(`https://api.bizzabo.com/api/partners?eventId=${process.env.BIZZABO_EVENT_ID}`, {
		"method": "GET",
		"headers": {
			"Content-Type": "application/json",
			"Authorization": "Bearer 67f61f9e-e897-4536-914e-3f47286650f9"
		}
	})
	const partnerData = await partners.json()


	
	return {
		props: { 
			seomatic: cmsData.data.entry.seomatic,
			partnerData: partnerData.content
		}
	}
}

export default Partners


